import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_back",
  "use": "icon_back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_back\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M9 14 4 9m0 0 5-5M4 9h10.5c.7223 0 1.4375.14226 2.1048.41866.6672.2764 1.2736.68154 1.7843 1.19224.5107.5107.9158 1.1171 1.1922 1.7843.2764.6673.4187 1.3825.4187 2.1048 0 .7223-.1423 1.4375-.4187 2.1048-.2764.6672-.6815 1.2736-1.1922 1.7843-.5107.5107-1.1171.9158-1.7843 1.1922-.6673.2764-1.3825.4187-2.1048.4187H11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol